/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Localité de rattachement d\'une localité (`localite_parent_id`), un seul niveau. Portée aussi\npar les codes postaux secondaires d\'une même commune : seul `Localite.type` permet de\nreconnaître une ancienne commune ou une commune déléguée.\n
 */
export const localiteParenteSchema = z.object({
      "nom": z.string().describe("Nom de la commune de rattachement"),
  "codePostal": z.string().describe("Code postal de la commune de rattachement")
      }).describe("Localité de rattachement d'une localité (`localite_parent_id`), un seul niveau. Portée aussi\npar les codes postaux secondaires d'une même commune : seul `Localite.type` permet de\nreconnaître une ancienne commune ou une commune déléguée.\n")